export const SignUpRoleDescriptionContent = {
  recruiter: {
    title: 'Recruiter',
    info:
      'Significantly increase placements of prescreened candidates.\n\nSend up to 5 candidates per job posting for free.\n\nReduce data entry - candidates get a shareable link to upload their own info.\n\nFor registered recruiters only.',
  },
  employer: {
    title: 'Employer',
    info:
      'Receive qualified candidates for your job postings from many recruiting agencies.\n\nSet up a desirable budget for service fees.\n\nEasily track your candidates and reduce turnaround time.\n\nPost a job and watch your pool grow.',
  },
};

export const signUpComleteContent = {
  recruiter: {
    title: ' Thank you for registering!',
    text:
      'Welcome to BoostHiring community! AND thank you for creating your account as a Recruiter. Your account will be activated within 48 hours after completing verification process. You should receive an activation email shortly.',
  },
  employer: {
    title: ' Thank you for registering!',
    text:
      'Welcome to BoostHiring community! AND thank you for creating your account as an Employer. Now you can login and start working on your orders.',
    button: 'Go to My Dashboard',
  },
};
